export const translation = {
  hotel: {
    'Distance to lift': 'Avstand til heis',
    'Distance to town centre': 'Avstand til sentrum',
    'Distance to skibus': 'Avstand til skibuss',
    'Customer rating': 'Gjesters karakterer',
    'Book now': 'Bestill nå',
    'Show photos': 'Vise bilder',
    'Rooms at ': 'Rom på ',
    'Guest reviews': 'Gjesteanmeldelser',
    'Guest review description':
      'Sitatene våre er hentet fra spørreskjemaer som fylles ut av gjestene våre etter reisen. Vi er stolte over at mange av våre gjester kommer tilbake år etter år. Etter forrige vintersesong (2024) svarte over 93 % av gjestene at de ønsker å reise med oss igjen.',
    'Hotel facilities': 'Hotellfaciliteter',
    Yes: 'Ja',
    'Show all': 'Vis fler',
    'Show less': 'Vis færre',
    'Tripadvisor title': 'Toppkarakter på Tripadvisor',
    'Tripadvisor description':
      '{{rating}} stjerner basert på {{numberOfRatings}} anmeldelser',
    'Tripadvisor link': 'Les mer på Tripadvisor',
    AUT: 'Østerrike',
    ITA: 'Italia',
    FRA: 'Frankrike',
    'Title template': 'Bestill {{hotel}} i {{destination}}, {{country}}',
  },
  booking: {
    StartingPrice: 'Bestill fra {{price}},- per pers.',
    PerPersonPrice: 'Bestill fra {{price}},- per pers.',
    PerPersonPriceCurrency: '{{price}},- per pers.',
    FamilyPrice: 'Familiepris fra {{price}},-',
    TotalPrice: 'Totalpris fra {{price}},-',
    FlightPrice: 'Kun fly fra {{price}},-',
    Currency: 'kr',
    Savings: 'Spar {{price}} kr',
    'All destinations': 'Alle destinasjoner',
    PackagePrice: 'Bestill Alp Inclusive fra {{price}},- per pers.',
    'Could not find any proposals':
      'Vi har ingen ledige turer på den valgte avgangen {{date}}.',
    'No proposals found':
      'Fant ingen forslag. Prøv å endre filtrering eller søk på en annen dato',
    'Show period': 'Vis periode {{date}}',
    'Book now': 'Bestill nå',
    'Send request': 'Send forespørsel',
    'Coming soon': 'Kommer snart',
    Traveltype: 'Reisetype',
    From: 'Fra',
    To: 'Til',
    Traveldate: 'Dato',
    Travelers: 'Reisende',
    Search: 'Søk reise',
    'Book trip': 'Bestill reise',
    'Week short': 'u.',

    Room: 'Rom',
    Rooms: 'Rom',

    room: 'rom',
    rooms: 'rom',

    adult: 'Voksen',
    Adults: 'Voksne',
    adults: 'voksne',
    'No adults': 'Ingen voksen',
    'Children Ages': 'Barn/ung. (0-17 år):',
    Child: 'Barn',
    child: 'barn',
    Children: 'Barn',
    children: 'barn',
    'No children': 'Ingen barn',
    'Age children': 'Alder barn/ung. (på hjemreisedagen):',

    'Child nr': 'Barn {{nr}}',
    'Rooms and travelers': 'Rom og reisende',
    years: 'år',
    MonthShort: {
      1: 'jan',
      2: 'feb',
      3: 'mar',
      4: 'apr',
      5: 'mai',
      6: 'jun',
      7: 'jul',
      8: 'aug',
      9: 'sep',
      10: 'okt',
      11: 'nov',
      12: 'des',
    },
    Charter: 'Pakkereise',
    Hotel: 'Bare hotell',
    Flight: 'Bare fly',
    'Find trip': 'Søk reise',
    'Add room': 'Legg til rom',
    'Remove room': 'Fjern rom',
    charterTypes: {
      Winter: 'Skireiser',
      Summer: 'Sommerreiser',
      Christmas: 'Julbordsresor',
      Hiking: 'Vandringsreiser',
    },
    priceReference:
      'Gjelder reise fra {{airport}} {{travelDateFrom}} på {{hotelName}}  i {{roomDescription}}',
    priceReferenceWithoutHotel:
      'Gjelder reise fra {{airport}} {{travelDateFrom}} i {{roomDescription}}',
    'Find price and book': 'Se pris & bestill',
    Close: 'Lukke',
    'More than 9 travelers?': 'Flere enn 9 reisende? Klikk her',
  },
  labels: {
    'city-center': 'Sentrum',
    'city-centre-value': '{{value}} m',
    'ski-bus': 'Skibuss',
    'ski-bus-value': '{{value}} m',
    'ski-lift': 'Skiheis',
    'ski-lift-value': '{{value}} m',
    'black-runs': 'Svarte løyper',
    'black-runs-value': '{{value}} stk',
    'red-runs': 'Røde løyper',
    'red-runs-value': '{{value}} stk',
    'blue-runs': 'Blå løyper',
    'blue-runs-value': '{{value}} stk',
    peak: 'Høyeste skikjøring',
    'peak-value': '{{value}} m',
    valley: 'Høyde over havet',
    'valley-value': '{{value}} m',
    vertical: 'Fallhøyde',
    'vertical-value': '{{value}} m',
    'piste-length': 'Løyper',
    'piste-length-value': '{{value}} km',
    'ski-lifts': 'Heiser',
    'ski-lifts-value': '{{value}} stk',
    'transfer-time': 'Transfertid',
    'transfer-time-value': '{{value}}',
    'cross-country-trails': 'Langrennspor',
    'cross-country-trails-value': '{{value}} km',
    restaurants: 'Restauranger',
    'restaurants-value': '{{value}}',
    'mountain-restaurants': 'Bergsrestauranger',
    'mountain-restaurants-value': '{{value}}',
    'after-ski-bars': 'Afterski-ställen',
    'after-ski-bars-value': '{{value}}',
    bars: 'Barer',
    'bars-value': '{{value}}',
    monday: 'Mandag',
    tuesday: 'Tirsdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lørdag',
    sunday: 'Søndag',
    closed: 'Stengt',
  },
  footer: {
    'Select country': 'Velg land',
    News: 'Nyhet!',
    'E-mail address': 'E-postadresse',
    Subscribe: 'Abonner',
  },
  header: {
    'Open hours today': 'Åpent idag kl',
    Menu: 'Meny',
    Start: 'Start',
  },
  error: {
    'Page not found': 'Siden kunne ikke bli funnet',
    'Page not found description':
      'Prøv å finne siden i menyen ovenfor eller skriv inn lenken på nytt.',
  },
  charts: {
    variable: 'Sammenlign',
    destination: 'Destinasjon',
    avg_snowfall: 'Snøfall',
    snowfall_days: 'Snødager',
    avg_snow_depth: 'Snødyp',
    biggest_snowfall: 'Største snøfall',
    all: 'Alle destinasjoner ',
    December: 'Desember',
    Januari: 'Januar',
    Februari: 'Februar',
    Mars: 'Mars',
    April: 'April',
  },
  countdown: {
    DAYS: 'Dager',
    HOURS: 'Timmer',
    MINUTES: 'Minutter',
    SECONDS: 'Sekunder',
  },
  profile: {
    hero: {
      greeting: 'Hei {0}',
      header: 'Min reise',
      message: 'Hei {0}, velkommen til reisen din',
      afterTripMessage: 'Takk for at du reiser med oss {0}. Velkommen igjen!',
      daysLeft: 'dager til avreise',
      title: 'Du reiser til {0}',
    },
    flight: {
      header: 'Reiseinformasjon',
      travelTime: 'Reisetid',
      addSki: 'Legg til ski frakt',
      luggage: '{0} innsjekket bagasje per person maks {0} er inkludert',
      skiLuggage: '1 par ski + staver, 1 par skistøvler, 1 hjelm - maks {0}',
    },
    summary: {
      header: 'Oppsummering',
      header2: 'Betaling',
      isPaid: 'Reisen din er betalt',
      isCancelled: 'Reisen din er kansellert',
      bookingNumber: 'Bestillingsnummer',
      bookingDate: 'Bestillingsdato',
      bookingPerson: 'Bestilles av',
      bookingPrice: 'Totalpris',
      bookingFee: 'Registreringsavgift ',
      bookingFeeHelp: 'Siste betalingsfrist {0}',
      bookingPayment: 'Sluttbetaling',
      bookingPaymentHelp: 'Betalingsfrist {0}',
      hint1:
        'Når reisen er betalt i sin helhet kan du laste ned din billett her',
      hint2:
        'I neste steg velger du om du vil betale påmeldingsavgiften eller hele reisen',
      email: 'E-post',
      phoneNumber: 'Telefon',
      paid: 'Betalt så langt',
      leftToPay: 'Igjen å betale',
    },
    tabs: {
      booking: 'Bestilling',
      faq: 'FAQ',
      addons: 'Tilvalg',
    },
    travellers: {
      header: 'Reisende',
      name: 'Navn',
      room: 'Rom',
      type: 'Type',
      typeAdult: 'Voksen',
      typeChild: 'Barn',
      dateOfBirth: 'Fødselsdato',
      gender: 'Kjønn',
      genderMale: 'Mann',
      genderFemale: 'Kvinne',
      notice:
        'Vil du legge til flere reisende? Kontakt oss på info@alpereiser.no eller <span>21 31 49 00</span>',
    },
    destination: {
      header: 'Reisemål og hotell',
      destination: 'Reisemål',
      hotel: 'Hotell',
      checkIn: 'Sjekk inn',
      checkOut: 'Sjekk ut',
      package: 'Pakke',
      linkLabel: 'Rom og reisende',
      linkText: 'Se lenger ned',
    },
    includes: {
      header: 'Mine tilvalg',
      seeAll: 'Se flere alternativer',
      edit: 'Rediger',
      included: 'Inkludert',
      skiSchool: 'Skiskole',
      excursion: 'Utflukt',
      skiRental: 'Skileie',
      skiPass: 'Heiskort',
      flightMeal: 'Flymat',
      skiLuggage: 'Skibagasje',
      transfer: 'Transfer',
      travelInsurance: 'Reiseforsikring',
      hiking: 'Vandring',
      travelers: '{0} st',
      pricing: 'á {0}',
    },
    addons: {
      deadline: 'Bestill senest {0}',
      order: 'Legg til',
      durationDays: '{0} dager',
      durationDay: '{0} dag',
      addonSkiCategory: 'Ski',
      addonFlightCategory: 'Fly',
      addonHikingCategory: 'Vandring',
      addonExcursionCategory: 'Andre aktiviteter',
      addonNoneCategory: 'Andre',
    },
    cta: {
      depositLeftText: 'Sikre reisen - betal {0} nå',
      notPayedText: 'Sluttbetal reisen din',
      allPayedText: 'Reisen er betalt',
      logout: 'Logg deg ut',
    },
    activities: {
      heading: 'Ukens aktiviteter',
      description:
        'Vi i STS Alpreiser organiserer mange utflukter og arrangementer sammen med guider og andre gjester som du kan ta del av under reisen.',
    },
    bookingConfirmation: {
      isPaid: 'Last ned billetten',
      notPaid: 'Last ned bestillingsbekreftelsen',
    },
    login: {
      form: {
        bookingRefLabel: 'Bestillingsnummer ',
        bookingRefPlaceholder: '00000000',
        emailLabel: 'E-mail',
        emailPlaceholder: 'du@exempel.se',
        submitLabel: 'Login',
        errorMessage:
          'Noe gikk galt, sjekk om du har lagt inn riktig informasjon. ',
      },
    },
  },
};
